import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import styles from './WeatherIcon.module.scss';

interface IProps {
  openWeatherIconName: string;
}

const openWeatherIconMap = {
  '01d': 'wi-day-sunny',
  '01n': 'wi-night-clear',
  '02d': 'wi-day-cloudy',
  '02n': 'wi-night-alt-cloudy',
  '03d': 'wi-cloud',
  '03n': 'wi-cloud',
  '04d': 'wi-cloudy',
  '04n': 'wi-cloudy',
  '09d': 'wi-showers',
  '09n': 'wi-showers',
  '10d': 'wi-day-rain',
  '10n': 'wi-night-alt-rain',
  '11d': 'wi-thunderstorm',
  '11n': 'wi-thunderstorm',
  '13d': 'wi-snow',
  '13n': 'wi-snow',
  '50d': 'wi-fog',
  '50n': 'wi-fog',
};

const WeatherIcon: FunctionComponent<IProps> = ({ openWeatherIconName }) => {
  const iconForOpenWeatherIcon = (opIconName) => {
    const mappedIcon = openWeatherIconMap[opIconName];

    if (mappedIcon) return mappedIcon;

    return 'na';
  };

  return <div className={classNames(`wi ${iconForOpenWeatherIcon(openWeatherIconName)}`, styles.icon)} />;
};
export default WeatherIcon;
